export const SET_USER_DATA = "SET_USER_DATA";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const REFERRER_USER = "REFERRER_USER";
export const COLOR_BRANDING = "COLOR_BRANDING";
